import { Button, Grid, List, ListItem, Typography } from '@mui/material';
import { useState } from 'react';
import { useFindAllRmasQuery, useFindOneRmaQuery } from '../../api/api-hooks';
import DisplayItemDialog from '../../components/DisplayItemDialog';

interface Props {
  serial: string;
}

const RmaHistoryDisplay = ({ serial }: Props) => {
  const { data: rmas } = useFindAllRmasQuery({});
  const [dialogSelection, setDialogSelection] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  if (rmas === undefined) return <></>;
  const selectedRmas = rmas.filter((rma) => rma.hardware.serial === serial);
  if (selectedRmas.length < 1)
    return <Typography>No RMA history for this hardware.</Typography>;
  const handleOpenItem = (id: number) => {
    setDialogSelection(id);
    setDialogOpen(true);
  };
  return (
    <>
      <DisplayItemDialog
        itemGetter={useFindOneRmaQuery}
        itemId={dialogSelection}
        dialogTitle='RMA'
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
      />
      <List>
        {selectedRmas.map((selectedRma) => (
          <Grid container>
            <Grid item>
              <ListItem>
                <Typography>{selectedRma.nameId}</Typography>
              </ListItem>
            </Grid>
            <Grid item>
              <Button
                onClick={() => {
                  handleOpenItem(selectedRma.id);
                }}
              >
                View
              </Button>
            </Grid>
          </Grid>
        ))}
      </List>
    </>
  );
};

export default RmaHistoryDisplay;
